import { categoryImportName, categoryNames } from '@inference.engine/guidelines/web';
import type { GuidelineResponseDto } from '@/lib/api/guidelines-client';

export interface GuidelineFormSheetProps {
  open: boolean;
  mode: 'create' | 'edit';
  /** Required in edit mode, ignored in create mode. */
  guideline?: GuidelineResponseDto | null;
  folderId?: string;
  onClose: () => void;
}

/** Text files go to the import route; everything else routes through AI generation. */
export const TEXT_FILE_FORMATS: Record<string, string[]> = {
  'text/plain': ['.txt'],
  'text/markdown': ['.md'],
};

const GENERATE_FILE_FORMATS: Record<string, string[]> = {
  'application/pdf': ['.pdf'],
  'image/jpeg': ['.jpeg', '.jpg'],
  'image/png': ['.png'],
};

export const ACCEPTED_FILE_FORMATS: Record<string, string[]> = {
  ...TEXT_FILE_FORMATS,
  ...GENERATE_FILE_FORMATS,
};

export const SHOWCASED_FORMATS = ['PDF', 'JPEG', 'JPG', 'PNG', 'TXT', 'MD'];
export const MAX_FILE_SIZE_MB = 100;

/**
 * The guidelines-api `guideline.name` and `guideline.description` column widths. Imports and AI
 * generation store values this long, and the browser rejects typing into a value already over
 * `maxLength`, so a lower cap leaves such a guideline delete-only.
 */
export const MAX_NAME_LENGTH = 255;
export const MAX_DESCRIPTION_LENGTH = 4096;

export const STRUCTURED_FORMAT_EXAMPLE = `Name: Logo clear space
Description: Keep a clear space around the logo equal to the height of the logo mark.
Category: Brand Assets
Positive Example: The logo sits alone on a plain background.
Negative Example: A headline touches the edge of the logo.

Name: Active voice
Description: Write marketing copy in the active voice.
Category: Content Style`;

/** Untranslated on purpose: the import matches these English names, whatever the UI language. */
export const STRUCTURED_FORMAT_CATEGORIES = categoryNames.map(categoryImportName).join(', ');
